import { trimText } from 'app/utils/utils';
import {
  GroupedVersionCredits,
  ReleaseVersionContribution,
  ValidationError,
} from 'types/releases';
import { Skeleton, SkeletonCircle, Text } from '@chakra-ui/react';
import { ContributionClassRolesDDL } from 'types/contribution';
import { UpdateVersionCreditsEffectData } from 'app/store/Releases/effects.types';
import { getConnexValidationMessage } from '../utils';

export const getLegalName = (
  credit: GroupedVersionCredits,
  isTrim: boolean
) => {
  const { firstName = '', lastName = '' } =
    credit.contribution.snapshot.contributor.profileCard || {};

  const legalName = `${firstName} ${lastName}`.trim();

  if (isTrim) {
    return trimText(legalName, 50);
  }
  return legalName;
};

export const getContributionIPI = (credit: GroupedVersionCredits) =>
  credit.contributions.find(
    (contribution) => contribution.snapshot?.contributor?.ipi
  )?.snapshot?.contributor?.ipi;

export const getContributionIPN = (credit: GroupedVersionCredits) =>
  credit.contributions.find(
    (contribution) => contribution.snapshot?.contributor?.ipn
  )?.snapshot?.contributor?.ipn;

export const getContributionISNI = (credit: GroupedVersionCredits) =>
  credit.contributions.find(
    (contribution) => contribution.snapshot?.contributor?.isni
  )?.snapshot?.contributor?.isni;

const NBSP = '\u00A0';
export const getSeparator = (symbol = '·') => (
  <Text color="textSubdued">
    {NBSP}
    {symbol}
    {NBSP}
  </Text>
);

export const getListLoadingOptions = (loading?: boolean) => ({
  loading: Boolean(loading),
  withSubheader: true,
  repeat: 3,
  loader: {
    role: <Skeleton width="60%" height="24px" />,
    date: <Skeleton width="40%" height="24px" />,
    country: <Skeleton width="40px" height="24px" />,
    addedBy: <Skeleton width="50%" height="24px" />,
    location: <Skeleton width="50%" height="24px" />,
    credited: <SkeletonCircle width="24px" height="24px" />,
  },
});

export const getSubheaderProps = ({
  contribution,
  rolesDDL,
  updateCreditsList,
}: {
  contribution: ReleaseVersionContribution;
  rolesDDL: ContributionClassRolesDDL;
  updateCreditsList: (data: UpdateVersionCreditsEffectData) => Promise<void>;
}) => {
  const { date, location, role, roleDetail } = contribution.snapshot || {};
  const roleColumn =
    rolesDDL[roleDetail || '']?.name ||
    rolesDDL[role || '']?.name ||
    role ||
    'No Role Selected';
  const addedByColumn =
    contribution.snapshot?.createdBy?.profileCard?.displayName;
  const menuOptions = [
    {
      title: contribution.isExcluded ? 'Add' : 'Remove',
      value: contribution.isExcluded ? 'Add' : 'Remove',
      onClick: () =>
        updateCreditsList({
          contributionGuid: contribution.contributionGuid,
          body: {
            isExcluded: !contribution.isExcluded,
          },
          showSnackBar: true,
        }),
    },
  ];

  return {
    roleColumn,
    addedByColumn,
    menuOptions,
    date,
    location,
  };
};

export const getErrorMsg = (
  contribution: ReleaseVersionContribution,
  validationErrors?: ValidationError[]
) => {
  const msg = getConnexValidationMessage(
    validationErrors?.find(
      ({ contributionGuid }) =>
        contributionGuid === contribution.contributionGuid
    )?.errorCode
  );

  return msg;
};
